var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOffline)?_c('div',{staticClass:"flex bg-red-light p-4 text-white text-center"},[_c('i',{staticClass:"la la-plug mx-1"}),_vm._v(" POS is offline\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }